import {
  AnyAnimatableProperty,
} from '@figmotion/figmotion-core';

export const BetaUserOnlyProperties: AnyAnimatableProperty[] = [];
